import React, { createContext, useReducer, useEffect } from "react";
import AppReducer from "./AppReducer";
import ReactGA from 'react-ga';

const initialState = {
  userData: null,
  createFolderModalIsOpen: false,
  moveModalIsOpen: false,
  moveEntityType: null,
  moveEntity: null,
};

export const GlobalContext = createContext(initialState);

//----------------------------------------------------------------------------
const localState = JSON.parse(localStorage.getItem("state"));

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, localState || initialState);

  useEffect(() => {
    localStorage.setItem("state", JSON.stringify(state));
  }, [state]);

  // Actions
  function openCreateFolderModal() {
    ReactGA.modalview('/create-folder');
    dispatch({
      type: "OPEN_CREATE_FOLDER_MODAL",
    });
  }

  function closeCreateFolderModal() {
    dispatch({
      type: "CLOSE_CREATE_FOLDER_MODAL",
    });
  }

  function openMoveModal(entity, entityType) {
    ReactGA.modalview('/move');
    dispatch({
      type: "OPEN_MOVE_MODAL",
      entityType,
      entity,
    });
  }

  function closeMoveModal() {
    dispatch({
      type: "CLOSE_MOVE_MODAL",
    });
  }

  function setMoveEntityType(entityType) {
    dispatch({
      type: "SET_MOVE_ENTITY_TYPE",
      entityType,
    })
  }

  function logIn(stateData) {
    dispatch({
      type: "LOGIN",
      stateData,
    });
  }

  function logOut() {
    dispatch({
      type: "LOGOUT",
      initialState,
    });
  }

  function initUser(userData) {
    dispatch({
      type: "INIT_USER",
      userData,
    });
  }

  function updateUser(updatedUserData) {
    dispatch({ type: "UPDATE_USER", updatedUserData });
  }

  return (
    <GlobalContext.Provider
      value={{
        userData: state.userData,
        logIn,
        logOut,
        initUser,
        updateUser,
        createFolderModalIsOpen: state.createFolderModalIsOpen,
        openCreateFolderModal,
        closeCreateFolderModal,
        moveModalIsOpen: state.moveModalIsOpen,
        openMoveModal,
        closeMoveModal,
        moveEntityType: state.moveEntityType,
        moveEntity: state.moveEntity,
        setMoveEntityType,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
